import { useEffect, useState } from "react"
import { UserType } from "../types/models/User"
import client from "../apis/client"

export const useTeamMember = () => {

    const [ teamMemberList, setTeamMemberList ] = useState<UserType[]>( [] )
    const [ belongToTeam, setBelongToTeam ] = useState( true )

    useEffect( () => {
        fetchTeamMember()
    }, [] )

    const fetchTeamMember = async () => {
        await client.get( `/api/community/me/`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        } )
            .then( response => {
                setBelongToTeam( true )
                setTeamMemberList( response.data.member )
            } )
            .catch( error => {
                console.warn( error )
                error.response.status === 400 && setBelongToTeam( false )
            } )
    }

    return teamMemberList
}
